/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScriptExecutionLog } from './ScriptExecutionLog.js';
import {
    ScriptExecutionLogFromJSON,
    ScriptExecutionLogFromJSONTyped,
    ScriptExecutionLogToJSON,
} from './ScriptExecutionLog.js';

/**
 * 
 * @export
 * @interface ContactScriptExecutionResult
 */
export interface ContactScriptExecutionResult {
    /**
     * 
     * @type {number}
     * @memberof ContactScriptExecutionResult
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactScriptExecutionResult
     */
    scriptId?: number;
    /**
     * 
     * @type {Date}
     * @memberof ContactScriptExecutionResult
     */
    dateExecuted?: Date;
    /**
     * 
     * @type {number}
     * @memberof ContactScriptExecutionResult
     */
    durationNanoseconds?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactScriptExecutionResult
     */
    memoryUsageBytes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContactScriptExecutionResult
     */
    isSuccess?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContactScriptExecutionResult
     */
    failureReason?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactScriptExecutionResult
     */
    failureMessage?: string;
    /**
     * 
     * @type {Array<ScriptExecutionLog>}
     * @memberof ContactScriptExecutionResult
     */
    logs?: Array<ScriptExecutionLog>;
}

/**
 * Check if a given object implements the ContactScriptExecutionResult interface.
 */
export function instanceOfContactScriptExecutionResult(value: object): boolean {
    return true;
}

export function ContactScriptExecutionResultFromJSON(json: any): ContactScriptExecutionResult {
    return ContactScriptExecutionResultFromJSONTyped(json, false);
}

export function ContactScriptExecutionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactScriptExecutionResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'scriptId': json['scriptId'] == null ? undefined : json['scriptId'],
        'dateExecuted': json['dateExecuted'] == null ? undefined : (new Date(json['dateExecuted'])),
        'durationNanoseconds': json['durationNanoseconds'] == null ? undefined : json['durationNanoseconds'],
        'memoryUsageBytes': json['memoryUsageBytes'] == null ? undefined : json['memoryUsageBytes'],
        'isSuccess': json['isSuccess'] == null ? undefined : json['isSuccess'],
        'failureReason': json['failureReason'] == null ? undefined : json['failureReason'],
        'failureMessage': json['failureMessage'] == null ? undefined : json['failureMessage'],
        'logs': json['logs'] == null ? undefined : ((json['logs'] as Array<any>).map(ScriptExecutionLogFromJSON)),
    };
}

export function ContactScriptExecutionResultToJSON(value?: ContactScriptExecutionResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'scriptId': value['scriptId'],
        'dateExecuted': value['dateExecuted'] == null ? undefined : ((value['dateExecuted']).toISOString()),
        'durationNanoseconds': value['durationNanoseconds'],
        'memoryUsageBytes': value['memoryUsageBytes'],
        'isSuccess': value['isSuccess'],
        'failureReason': value['failureReason'],
        'failureMessage': value['failureMessage'],
        'logs': value['logs'] == null ? undefined : ((value['logs'] as Array<any>).map(ScriptExecutionLogToJSON)),
    };
}

